module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/63e5827c1506216bd7c9927a4e5eb558.svg";